import { render, staticRenderFns } from "./Faucet.vue?vue&type=template&id=1b9c1bdb&scoped=true&"
import script from "./Faucet.vue?vue&type=script&lang=js&"
export * from "./Faucet.vue?vue&type=script&lang=js&"
import style0 from "./Faucet.vue?vue&type=style&index=0&id=1b9c1bdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c1bdb",
  null
  
)

export default component.exports